module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/august-066d68671a748a3410e24aec0bad20ab.png";